// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".psw-form[data-v-7e16e0d3]{width:80%;margin:0 auto}", ""]);
// Exports
module.exports = exports;
